import styled from "styled-components";

export default styled.thead`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-bottom: ${({ borderColor }) => `1px solid ${borderColor}`};
  font-size: ${({ fontSize = "0.875rem" }) => fontSize};
`;
